import Vue from 'vue';
import axios from 'axios';

import { Message } from 'element-ui';
import Qs from 'qs';

import { baseUrl } from './dataService';

axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use(
  function (config) {
    if (config.data) {
      config.data = Qs.stringify(config.data);
    }
    return config;
  },
  function (error) {
    Message({
      message: error.message || error.msg || 'Request failed',
      type: 'error',
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    if ('isSimple' in response.config) {
      const res = response.data;
      if (res.code === 1) return res.data;
      return Promise.reject(res);
    }

    return response;
  },
  function (error) {
    Message({
      message: error.message || error.msg || 'Response failed',
      type: 'error',
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  }
);

export default axios;
